import { withRouter } from 'react-router-dom';
import { BASE_URIS, LOCAL_STORAGE_ITEM_NAMES, TPIS_PARAMS } from "../components/domain/constants";
import { clearUserDataFromLocalStorage } from "./StorageUtil";
class Util {
  // redirects

  static loginRedirect(props) {
    const wasLoggedIn = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.role) != null || localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.partners) != null || localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.username) != null;
    if (props != null && props.location != null) {
      Util.log('Util.loginRedirect:1', false, 'Clearing local storage for login redirect from ' + props.location.pathname, false);
    }
    clearUserDataFromLocalStorage();
    if (props != null) {
      let path = '/login';
      let search = wasLoggedIn === true ? '?expired=true' : '';
      let state = {
        targetPathName: props.location.pathname,
        targetSearch: props.location.search
      };
      props.history.push({
        pathname: path,
        search: search,
        state: state
      });
    } else {
      Util.log('Util.loginRedirect:2', false, 'Could not redirect because props was null. Forcing reload');
      window.location.reload(true);
    }
  }
  static errorRedirect(props, message) {
    if (props != null && props.history != null) {
      let path = '/error?message=' + message;
      props.history.push(path);
    }
  }
  static fetchWithRedirect(uri, method, props, postBody) {
    return fetch(uri, {
      method: method,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'x-meta-tpic-partner': getSelectedPartner()
      },
      credentials: 'include',
      body: postBody != null ? JSON.stringify(postBody) : null
    }).then(resp => {
      if (resp == null) {
        console.error("response was null");
        return {};
      } else if (resp.status === 401) {
        Util.log('Util.fetchWithRedirect:1', false, "A call to '".concat(uri, "' resulted in a '401 - Unauthorized' response"), false);
        Util.loginRedirect(props);
        return {};
      } else if (resp.ok === false) {
        if (resp.status === 403 && props != null && props.history != null) {
          Util.log('Util.fetchWithRedirect:2', false, "A call to '".concat(uri, "' resulted in a '403 - Forbidden' response"), false);
        } else if (![400, 404].includes(resp.status)) {
          Util.errorRedirect(props, 'Internal Server Error. Please contact a site administrator and/or try again later');
          return {};
        }
      }
      const contentType = resp.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return resp.json();
      }
      return resp.text().then(text => {
        if (text && text.trim().length > 0) {
          try {
            return JSON.parse(text);
          } catch (e) {
            return {
              status: resp.status,
              message: text
            };
          }
        }
        return {
          status: resp.status
        };
      });
    }).catch(err => {
      Util.log('Util.fetchWithRedirect:3', true, err, false);
      return {};
    });
  }
  // log

  static log(handler, isError, message, logToConsole) {
    if (logToConsole === true) {
      if (isError === true) {
        console.error(message);
      } else {
        console.log(message);
      }
    }
    let logForm = new FormData();
    logForm.append('handler', handler);
    logForm.append('isError', isError);
    logForm.append('message', message);
    fetch('/log', {
      method: 'POST',
      credentials: 'include',
      body: logForm
    }).then();
  }

  // alert utils

  /**
   * The dialog is hidden by default and only displayed if this method is called
   */
  static createDialog(title, description, ref) {
    ref.setTitle(title);
    ref.setDescription(description);
    ref.handleClickOpen();
  }
  static openSnackbar(message, ref) {
    ref.setMessage(message);
    ref.handleOpen();
  }

  // visibility utils

  static isVisibleForRole(userRole, visibleRoles) {
    return userRole != null && (userRole.toLowerCase() === 'admin' || visibleRoles != null && visibleRoles.includes(userRole.toLowerCase()));
  }
  static isVisibleForCapabilities(capabilities, visibleToCapabilities) {
    for (let c of visibleToCapabilities) {
      if (capabilities.includes(c)) {
        return true;
      }
    }
    return false;
  }
  static async isVisibleForUser(entityProvider, entityId, props) {
    if (entityProvider != null && entityId != null) {
      let uri = BASE_URIS.prefix + BASE_URIS.isVisible;
      uri += "?".concat(TPIS_PARAMS.PROVIDER, "=").concat(entityProvider);
      uri += "&".concat(TPIS_PARAMS.ENTITY_ID, "=").concat(entityId);
      uri += "".concat(TPIS_PARAMS.IGNORE_UNRESOLVABLE_ENTITIES);
      return await Util.fetchWithRedirect(uri, 'GET', props).then(resp => {
        const visible = resp.visible;
        if (visible != null && visible !== '') {
          return visible;
        } else {
          return false;
        }
      }).catch(err => {
        Util.log('Util.isVisibleForUser:1', true, err, false);
        return false;
      });
    } else {
      return true;
    }
  }
}
export function getSelectedPartner() {
  return localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.selectedPartner);
}
export function statesDontMatch(field, prevState, state) {
  return prevState[field] !== state[field];
}
export default withRouter(Util);